import {myAxios} from "@/services/myAxios";
import {eventBus} from "@/main";
import L from "leaflet";
import dayjs from "dayjs";
import {loadTides} from "@/helpers/api";
import Chart from "chart.js/auto";

export function getDepth(coordinates) {
    let URL = 'api/v1/depth?lat=' + coordinates.lat + '&lon=' + coordinates.lng

    myAxios.get(URL).then(resp => {
        L.popup().setLatLng(coordinates).setContent(resp.data + ' m').openOn(this.map);
    })
}

export async function getDepthAsync(coordinates) {
    let URL = 'api/v1/depth?lat=' + coordinates.lat + '&lon=' + coordinates.lng
    const resp = await myAxios.get(URL);
    return resp?.data ?? -1;
}

export function getWeather(coordinates, time) {

    let URL = 'https://nogotiles.bgeo.fi:6011/weather_info?lat=' + coordinates.lat + '&lon=' + coordinates.lng + '&t=' + time

    myAxios.get(URL).then(resp => {
        let temperature = ''
        let wind = ''
        if (!resp.data.temperature.toString().startsWith('1.7976931348'))
            temperature = 'Temperature: ' + resp.data.temperature + '° C'

        if (!resp.data.wind.toString().startsWith('1.7976931348'))
            wind = 'Wind: ' + resp.data.wind + ' m/s (' + resp.data.windAngle + '°)'

        let content = 'Date: ' + dayjs.unix(time).format('DD-MMM HH:mm') + '<br>'
        content += temperature ? temperature + '<br>' : ''
        if (wind)
            content += wind

        L.popup().setLatLng(coordinates).setContent(content).openOn(this.map);
    }).catch(error => {
        let content = 'Date: ' + dayjs.unix(time).format('DD-MMM HH:mm') + '<br>'
        content += 'Weather is not available'
        L.popup().setLatLng(coordinates).setContent(content).openOn(this.map);
    })
}


export async function getWindyWeather(coordinates, time) {
    console.log('getWindyWeather called with coordinates:', coordinates, 'time:', time);
    
    try {
        await getWindyWeatherReal(coordinates, time);

    } catch (error) {
        console.error('Error fetching Windy weather data:', error);
        
        let errorMessage = 'Failed to load weather data';
        if (error.response?.status === 401) {
            errorMessage = 'Invalid API key';
        } else if (error.response?.status === 429) {
            errorMessage = 'API rate limit exceeded';
        } else if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
        } else if (error.message) {
            errorMessage = error.message;
        }

        // Показываем ошибку через eventBus
        eventBus.$emit('show-windy-weather-error', {
            coordinates,
            time,
            error: errorMessage
        });
    }
}

// Функция для вызова Windy API
export async function getWindyWeatherReal(coordinates, time) {
    console.log('getWindyWeatherReal called with coordinates:', coordinates, 'time:', time);
    
    try {
        // Конвертируем unix timestamp в ISO строку для Windy API
        const startTime = dayjs.unix(time).toISOString();
        
        // API ключ Windy
        const WINDY_API_KEY = 'Q8MxfNELIvJDbx01eiSUM4AfkNHsyz6t';
        
        // Запрос к основной GFS модели для погодных данных
        const mainRequestData = {
            lat: parseFloat(coordinates.lat),
            lon: parseFloat(coordinates.lng), 
            model: 'gfs',
            parameters: [
                'temp',      // температура
                'dewpoint',  // точка росы
                'rh',        // относительная влажность
                'wind',      // ветер (включает u и v компоненты)
                'windGust',  // порывы ветра
                'pressure',  // давление
                'precip',    // осадки
                'snowPrecip',// снег
                'lclouds',   // низкие облака
                'mclouds',   // средние облака  
                'hclouds'    // высокие облака
            ],
            levels: ['surface'],
            start: startTime,
            hours: 168,
            key: WINDY_API_KEY
        };

        // Запрос к GFS Wave модели для данных о волнах
        const waveRequestData = {
            lat: parseFloat(coordinates.lat),
            lon: parseFloat(coordinates.lng), 
            model: 'gfsWave',
            parameters: ['waves'],  // данные о волнах
            levels: ['surface'],
            start: startTime,
            hours: 168,
            key: WINDY_API_KEY
        };

        console.log('Main GFS API request data:', mainRequestData);
        console.log('GFS Wave API request data:', waveRequestData);

        // Выполняем оба запроса параллельно
        const [mainResponse, waveResponse] = await Promise.allSettled([
            myAxios.post('https://api.windy.com/api/point-forecast/v2', mainRequestData, {
                headers: { 'Content-Type': 'application/json' }
            }),
            myAxios.post('https://api.windy.com/api/point-forecast/v2', waveRequestData, {
                headers: { 'Content-Type': 'application/json' }
            })
        ]);

        console.log('Main GFS response status:', mainResponse.status);
        console.log('GFS Wave response status:', waveResponse.status);

        // Проверяем основной ответ
        if (mainResponse.status !== 'fulfilled' || !mainResponse.value?.data?.ts) {
            throw new Error('Invalid response structure from main GFS API');
        }

        const mainData = mainResponse.value.data;
        let waveData = null;

        // Проверяем ответ о волнах (может не работать для всех локаций)
        if (waveResponse.status === 'fulfilled' && waveResponse.value?.data?.ts) {
            waveData = waveResponse.value.data;
            console.log('Wave data successfully received');
        } else {
            console.log('Wave data not available for this location or failed to load');
        }

        // Объединяем данные
        const combinedData = { ...mainData };
        if (waveData) {
            combinedData['waves_height-surface'] = waveData['waves_height-surface'];
            combinedData['waves_period-surface'] = waveData['waves_period-surface'];
            combinedData['waves_direction-surface'] = waveData['waves_direction-surface'];
        }

        console.log('Combined API data keys:', Object.keys(combinedData));

        // Преобразуем данные в более удобный формат  
        const processedData = processWindyApiResponse(combinedData);
        
        // Показываем данные через eventBus
        eventBus.$emit('show-windy-weather', {
            coordinates,
            time,
            weatherData: processedData
        });

        return processedData;

    } catch (error) {
        console.error('Error fetching real Windy weather data:', error);
        console.error('Error response status:', error.response?.status);
        console.error('Error response data:', error.response?.data);
        
        let errorMessage = 'Failed to load weather data';
        
        if (error.response?.status === 401) {
            errorMessage = 'Invalid API key';
        } else if (error.response?.status === 429) {
            errorMessage = 'API rate limit exceeded';
        } else if (error.response?.status === 400) {
            errorMessage = 'Invalid request parameters: ' + (error.response?.data?.message || 'Bad Request');
        } else if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
        } else if (error.message) {
            errorMessage = error.message;
        }

        // Показываем ошибку через eventBus
        eventBus.$emit('show-windy-weather-error', {
            coordinates,
            time,
            error: errorMessage
        });

        throw error;
    }
}

// Функция для обработки данных Windy API в более удобный формат
function processWindyApiResponse(rawData) {
    console.log('Processing Windy API response:', rawData);
    
    // Конвертируем временные метки из миллисекунд в секунды
    const timestamps = rawData.ts ? rawData.ts.map(ts => Math.floor(ts / 1000)) : [];
    
    const processed = {
        ts: timestamps,
        // Температура (конвертируем из Кельвинов в Цельсии)
        temp_2m: rawData['temp-surface']?.map(k => Math.round((k - 273.15) * 10) / 10) || [],
        // Точка росы (конвертируем из Кельвинов в Цельсии)
        dewpoint_2m: rawData['dewpoint-surface']?.map(k => Math.round((k - 273.15) * 10) / 10) || [],
        // Влажность (уже в процентах)
        rh_2m: rawData['rh-surface'] || [],
        // Компоненты ветра (уже в м/с)
        wind_u_10m: rawData['wind_u-surface'] || [],
        wind_v_10m: rawData['wind_v-surface'] || [],
        // Порывы ветра (уже в м/с)
        wind_gust: rawData['gust-surface'] || [],
        // Давление (конвертируем из Па в hPa)
        surface_pressure: rawData['pressure-surface']?.map(pa => Math.round(pa / 100 * 10) / 10) || [],
        // Осадки (конвертируем из м в мм)
        rain_1h: rawData['past3hprecip-surface']?.map(m => Math.round(m * 1000 * 10) / 10) || [],
        rain_3h: rawData['past3hprecip-surface']?.map(m => Math.round(m * 1000 * 10) / 10) || [], // уже 3-часовые данные
        snow_1h: rawData['past3hsnowprecip-surface']?.map(m => Math.round(m * 1000 * 10) / 10) || [],
        snow_3h: rawData['past3hsnowprecip-surface']?.map(m => Math.round(m * 1000 * 10) / 10) || [], // уже 3-часовые данные
        // Облачность (уже в процентах)
        lclouds: rawData['lclouds-surface'] || [],    // низкие облака
        mclouds: rawData['mclouds-surface'] || [],    // средние облака  
        hclouds: rawData['hclouds-surface'] || [],    // высокие облака
        // Общая облачность (среднее из всех типов)
        clouds: [],
        // Данные о волнах (если доступны от gfsWave модели)
        waves_height: rawData['waves_height-surface']?.map(h => Math.round(h * 10) / 10) || [],
        waves_period: rawData['waves_period-surface']?.map(p => Math.round(p * 10) / 10) || [],
        waves_direction: rawData['waves_direction-surface']?.map(d => Math.round(d)) || [],
        // Пустые массивы для совместимости с демо-данными
        wind_u_80m: [],
        wind_v_80m: [],
        visibility: [], // Не доступно в GFS модели
        cape: [],
        uv_index: []
    };

    // Вычисляем скорость ветра из компонент u и v
    if (processed.wind_u_10m.length && processed.wind_v_10m.length) {
        processed.wind_speed_10m = processed.wind_u_10m.map((u, i) => {
            const v = processed.wind_v_10m[i] || 0;
            return Math.round(Math.sqrt(u * u + v * v) * 10) / 10;
        });
    }

    // Вычисляем общую облачность как среднее из низких, средних и высоких облаков
    if (processed.lclouds.length || processed.mclouds.length || processed.hclouds.length) {
        const maxLength = Math.max(
            processed.lclouds.length, 
            processed.mclouds.length, 
            processed.hclouds.length
        );
        
        for (let i = 0; i < maxLength; i++) {
            const low = processed.lclouds[i] || 0;
            const mid = processed.mclouds[i] || 0;
            const high = processed.hclouds[i] || 0;
            processed.clouds.push(Math.round((low + mid + high) / 3));
        }
    }

    console.log('Processed Windy API data:', processed);
    console.log('Sample processed data:');
    console.log('Temperature:', processed.temp_2m.slice(0, 5));
    console.log('Wind speed:', processed.wind_speed_10m?.slice(0, 5));
    console.log('Pressure:', processed.surface_pressure.slice(0, 5));
    console.log('Wave height:', processed.waves_height.slice(0, 5));
    
    return processed;
}

export function showInfo(coordinates) {
    let URL = 'api/v1/objectsinfo?lat=' + coordinates.lat + '&lon=' + coordinates.lng

    myAxios.get(URL).then(resp => {
        eventBus.$emit('show-map-info', {info: resp.data, coordinates: coordinates})
    })
}

export function deg2rad(deg) {
    return deg * (Math.PI / 180)
}

export function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    let R = 6371;
    let dLat = deg2rad(lat2 - lat1);
    let dLon = deg2rad(lon2 - lon1);
    let a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2)
    ;
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let d = R * c;
    return d;
}

